export const SummaryConfig = {
    name            : 'Summary',
    menuName        : 'Summary',
    icon            : 'ii5-information',
    image           : 'summary-image-1',
    iconSvg         : 'isvg-view-summary',
    url             : 'summary',
    stringId        : 'projects-summary',
    appName         : 'summary',
    description     : 'Provides a detailed overview of selected projects, allowing you to track progress, milestones, and key metrics.',
}

export const PROJECT_SUMMARY_CONFIG = {
    ...SummaryConfig,
    // key2: "newValue2",  // Replacing the value for key2
}
